<template>
  <div
    v-if="showSalesFloorWidget"
    class="salesfloor"
    :class="salesFloorClasses"
  >
    <SalesFloorWidget v-bind="salesFloorProps" />
  </div>
</template>

<script setup>
import SalesFloorWidget from '@common-vue/salesfloor';
import { useSalesFloorData } from '@composables/useSalesFloorData';

const { salesFloorProps, showSalesFloorWidget, salesFloorClasses } = useSalesFloorData();
</script>

<style lang="scss" >
@import "~settingSCSS";
.salesfloor {
  @include margin-top-m();
  .sf-virtual-advisor--stylist-title {
    @include header(h4);
  }
}
</style>
